import {
    SETUP,
    LOGIN_USER_SUCCESS,
    LOGOUT,
    VERIFICATION_FAILED,
    UPDATE_USER_SETTINGS,
    GET_USER_SETTINGS
} from '../actions/types';

const token = localStorage.getItem('token') || '';
const permissions = JSON.parse(localStorage.getItem('permissions')) || {};

const INITIAL_STATE = {
    user: null,
    token,
    permissions,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER_SUCCESS:
            return { ...state, token: state.token || action.payload.token, permissions: action.payload.permissions };
        case SETUP:
            return { ...state, permissions: action.payload.permissions, user: action.payload.user };
        case GET_USER_SETTINGS:
        case UPDATE_USER_SETTINGS:
            return {
                ...state,
                user: action.payload,
            };
        case LOGOUT:
        case VERIFICATION_FAILED:
            localStorage.clear();
            return { ...INITIAL_STATE, token: null, permissions: {} };
        default:
            return state;
    }
};
